/* Panier : fiche produit (produit + ajout facultatif en un envoi) et case « + 12 $ » du tiroir / de la page panier.
   API panier Ajax native de Shopify (/cart/add.js, /cart/change.js), sans appli tierce ni secret. */
(function () {
  'use strict';
  if (window.RbCart) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function url(p) { return (root + p).replace(/\/\//g, '/'); }
  function sectionsWanted() {
    var drawer = document.querySelector('cart-drawer');
    return drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ['cart-icon-bubble'];
  }
  function post(path, body) {
    body.sections = sectionsWanted();
    body.sections_url = location.pathname;
    return fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); });
  }
  function showCartIcon() {
    var icon = document.getElementById('cart-icon-bubble');
    if (icon) icon.hidden = false;
  }
  function refresh(json, openDrawer) {
    showCartIcon();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && json && json.sections && openDrawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(json);
      return;
    }
    if (json && json.sections && json.sections['cart-icon-bubble']) {
      var icon = document.getElementById('cart-icon-bubble');
      var doc = new DOMParser().parseFromString(json.sections['cart-icon-bubble'], 'text/html');
      var src = doc.querySelector('.shopify-section');
      if (icon && src) icon.innerHTML = src.innerHTML;
    }
    if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'rb-addon', cartData: json });
    } else if (!drawer) {
      location.reload();
    }
  }
  function money(cents) {
    var s = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '$' + s;
  }

  /* ---------- Fiche produit ---------- */
  function initProduct(form) {
    var addon = form.querySelector('[data-rb-addon-variant]');
    var btn = form.querySelector('[data-rb-add]');
    var express = form.querySelector('[data-rb-express]');
    var note = form.querySelector('[data-rb-express-note]');
    var err = form.querySelector('[data-rb-product-error]');
    function update() {
      if (!btn) return;
      var cents = parseInt(btn.getAttribute('data-price-cents'), 10) + (addon && addon.checked ? parseInt(addon.getAttribute('data-rb-addon-cents'), 10) : 0);
      btn.textContent = btn.getAttribute('data-label').replace('%p', money(cents));
      if (express) express.hidden = !!(addon && addon.checked);
      if (note) note.hidden = !(addon && addon.checked);
    }
    if (addon) addon.addEventListener('change', update);
    update();
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      if (err) err.hidden = true;
      var items = [{ id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: 1 }];
      if (addon && addon.checked) items.push({ id: parseInt(addon.getAttribute('data-rb-addon-variant'), 10), quantity: 1 });
      post('cart/add.js', { items: items })
        .then(function (json) { refresh(json, true); })
        .catch(function () { if (err) err.hidden = false; })
        .finally(function () { btn.removeAttribute('aria-busy'); });
    });
  }

  /* ---------- Case du tiroir / page panier (délégation : le tiroir est re-rendu à chaque mise à jour) ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    var wrap = input && input.closest && input.closest('[data-rb-addon]');
    if (!wrap || input.type !== 'checkbox') return;
    var id = parseInt(wrap.getAttribute('data-variant-id'), 10);
    var msg = wrap.querySelector('.rb-addon-err');
    wrap.setAttribute('aria-busy', 'true');
    if (msg) msg.hidden = true;
    var req = input.checked
      ? post('cart/add.js', { items: [{ id: id, quantity: 1 }] })
      : post('cart/change.js', { id: String(id), quantity: 0 });
    req.then(function (json) {
      // Page panier : le total est dans une autre section -> rechargement simple et fiable
      if (wrap.closest('cart-items') && !wrap.closest('cart-drawer')) { location.reload(); return; }
      refresh(json, false);
    }).catch(function () {
      input.checked = !input.checked;
      if (msg) { msg.textContent = wrap.getAttribute('data-error'); msg.hidden = false; }
    }).finally(function () { wrap.removeAttribute('aria-busy'); });
  });

  function boot() { document.querySelectorAll('[data-rb-product-form]').forEach(initProduct); }
  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  window.RbCart = { refresh: refresh };
})();
